// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3t-1";
export var movingGradient = "_3t-4";
export var movingGradientBlock = "_3t-2";
export var skeleton = "_3t-0";
export var skeletonText = "_3t-3";